<template functional>
  <div class="loader">
    <div class="CDB-LoaderIcon CDB-LoaderIcon--big">
      <svg class="CDB-LoaderIcon-spinner" viewBox="0 0 50 50">
        <circle class="CDB-LoaderIcon-path" cx="25" cy="25" r="20" fill="none"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
  }
</script>

<style scoped>
  .loader {
    position: absolute;
    background: rgba(46, 60, 67, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    opacity: 1;
    transition: opacity 300ms;
    pointer-events: none;
  }

  .CDB-LoaderIcon--big {
    width: 40px;
    height: 40px;
  }

  .CDB-LoaderIcon-spinner {
    width: 40px;
    height: 40px;
    animation: rotate 2s linear infinite;
  }

  .CDB-LoaderIcon-path {
    stroke: rgba(255, 255, 255, .88);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
    stroke-width: 4px
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg)
    }
  }
</style>
